import { WebCamera, type CameraCapability } from './camera.js'
import { WebFileSystem, type FileSystemCapability } from './filesystem.js'
import { WebGeolocation, type GeolocationCapability } from './geolocation.js'
import { WebNetwork, type NetworkCapability } from './network.js'

export interface Platform {
  camera: CameraCapability
  filesystem: FileSystemCapability
  geolocation: GeolocationCapability
  network: NetworkCapability
}

export const platform: Platform = {
  camera: new WebCamera(),
  filesystem: new WebFileSystem(),
  geolocation: new WebGeolocation(),
  network: new WebNetwork()
}
